import React, { useState } from "react";
import ShopCardGraphic from "./ShopCardGraphic";
import { toast } from "@jammable/ui-core";
import axios from "axios";
import { requireIdToken } from "../../utils/firebaseAuth";
import { Spinner } from "@jammable/ui-components/Loader";
// "/pure": see CreditCheckoutModal - load Stripe.js on use, not on import.
import { loadStripe } from "@stripe/stripe-js/pure";
import useAuthModal from "../../hooks/useAuthModal";
import useSubscription from "../../hooks/useSubscription";
import { formatCurrency } from "@jammable/ui-payments-feature/src/utils";

const ShopCard = ({ item, hasDiscount }) => {
  const [loading, setLoading] = useState(false);
  const { checkAuthAndExecute } = useAuthModal();

  const startCheckout = async () => {
    if (!checkAuthAndExecute()) return false;

    setLoading(true);
    try {
      const token = await requireIdToken();
      const res = await axios.post(
        `/api/payment/createCustomCheckoutSession`,
        { quantity: item.amount, currency: "USD" },
        {
          headers: {
            Authorization: token,
          },
        },
      );
      const sessionId = res.data.sessionId;
      try {
        const stripe = await loadStripe(
          process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
        );

        stripe.redirectToCheckout({ sessionId }).catch((err) => {
          toast.error(
            `Error redirecting to checkout. Please check your browser settings or try a new device/browser.`,
          );
        });
      } catch (error) {
        setLoading(false);
        console.error("Error loading Stripe:", error);
      } // Handle the response here
    } catch (error) {
      toast.error(`Something went wrong, please try again.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      key={item.name}
      className="tw-flex tw-w-full tw-flex-col tw-items-stretch tw-gap-3 tw-rounded-[30px] tw-bg-white tw-p-3 tw-pb-4 tw-text-jam-ink"
    >
      <ShopCardGraphic amount={item.amount} gem={item.gem} />
      <div className="tw-flex tw-items-end tw-justify-between tw-gap-3 tw-px-2">
        <div className="tw-min-w-0">
          <div className="tw-text-lg tw-font-extrabold">{item.name}</div>
          <div className="tw-text-[13px] tw-font-semibold tw-text-jam-muted">
            {item.amount} voice passes
          </div>
        </div>
        <div className="tw-flex tw-shrink-0 tw-items-baseline tw-gap-1.5">
          <div
            className={`tw-text-[13px] tw-font-bold tw-text-jam-muted ${hasDiscount ? "tw-line-through" : "tw-hidden"}`}
          >
            {formatCurrency(item.price * 100, "USD")}
          </div>
          <div className="jam-display tw-text-[26px] tw-font-extrabold tw-leading-none">
            {hasDiscount
              ? formatCurrency(item.price * 50, "USD")
              : formatCurrency(item.price * 100, "USD")}
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={startCheckout}
        className="tw-mx-1 tw-flex tw-h-12 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-jam-lime tw-text-[15px] tw-font-extrabold tw-text-jam-ink tw-transition-opacity hover:tw-opacity-90 disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
        disabled={loading}
      >
        {loading ? (
          <Spinner size={4} className="tw-border-jam-ink" />
        ) : (
          "Purchase"
        )}
      </button>
    </div>
  );
};

export default ShopCard;
